var styles = {"box":"Button_box_17af2_1","icon":"Button_icon_17af2_29","v2":"Button_v2_17af2_42"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
